/**
 * @fileOverView
 * @description Vybit App Entry Point<br>
 * @copyright 2015-present Flatirontek LLC, all rights reserved
 **/
import firebase from 'firebase/app';
import 'firebase/auth';

var app = require('ampersand-app');
var domready = require('domready');
var MainView = require('./views/main');
var socket = require('socket.io-client');
var YAML = require('yamljs');

global.jQuery = require('jquery');
global.Tether = require('tether');
global.dayjs = require('dayjs');
require('bootstrap');

// Custom URL scheme handler for vybit://.
window.handleOpenURL = function(url) {
    setTimeout(function() {
        if (typeof url !== "string" || !app.checkEmailSignIn) return;
        console.log('handleOpenURL:', url);
        try {
            var equivalentUrl = "https://signin.vybit.net/?" + new URL(url).searchParams.toString();
            app.checkEmailSignIn(equivalentUrl);
        } catch(e) {
            console.error("handleOpenURL error:", e);
        }
    }, 0);
};

app.extend({

    version: '1.9.0',

    config: require("./etc/config"),

    serviceAuth: false,

    onBackgroundMessageFired: false,

    back: false,

    tmpDisableScroll: false,

    vyb: null,

    incomingUrl: window.location.href,

    queryString: window.location.search.substring(1),

    YAML: YAML,

    pageContainer: function(){ document.querySelector('div[data-hook="vc"]'); },

    mainPageView: function(){ return new this.LogPageView(); },

    soundViews: {},

    eventLog: require('./lib/eventlog'),

    //load utilities
    utils: require('./lib/utilities'),
    fsutils: require('./lib/fsutils'),
    sfutils: require('./lib/sfutils'),
    glutils: require('./lib/glutils'),
    dialog: require('./lib/dialog'),

    initialize: function(){

        // Polyfill for setImmediate (not available in mobile WebViews)
        if (typeof setImmediate === 'undefined') {
            window.setImmediate = function(fn) {
                return setTimeout(fn, 0);
            };
            window.clearImmediate = function(id) {
                return clearTimeout(id);
            };
        }

        this.eventLog.add('initializing app');
        this.platform = document.URL.indexOf( 'http://' ) === -1 && document.URL.indexOf( 'https://' ) === -1 ? 'app' : 'browser';
        this.eventLog.add('app is ' + this.platform);
        if (this.platform=='app') {

            document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
            document.addEventListener('resume', this.onDeviceResume.bind(this), false);

        } else {
            this.platformId = 'web';
            this.init();
        }
    },

    appendBaseTag: function(){
        var newBase = document.createElement("base");
        newBase.setAttribute("href", "/www");
        document.getElementsByTagName("head")[0].appendChild(newBase);
    },

    onDeviceReady: function() {
        this.eventLog.add('reached onDeviceReady');
        this.receivedEvent('deviceready');

        if (typeof cordova !== 'undefined' && cordova.plugins && cordova.plugins.firebase) {
            this.registerNotificationHandlers();
        } else {
            // If no push notifications, check audio permission directly
            if (this.sfutils && this.platformId === 'android') {
                this.sfutils.checkAudioPermission();
            }
        }
    },

    onDeviceResume: function(){

        console.log('reached onDeviceResume');

        // Safety check: auth might not be initialized yet
        if(this.auth && this.auth.authenticated){
            this.loadLogs(false);
            this.loadUsedSounds();
        }

        //TODO, else if oobCode and client_id, checkEmailSignIn
        if(this.auth && this.queryParams.client_id!=undefined) this.auth.checkAuth();

    },

    registerNotificationHandlers: function() {
        const self = this;

        this.eventLog.add('registering notification handlers');

        cordova.plugins.firebase.messaging.requestPermission().then(function() {
            console.log("Push messaging is allowed");
        }).catch(function(error) {
            console.error('Push permission error:', error);
        }).finally(function() {
            // After push notification permission is handled, check audio permission
            if (self.sfutils && self.platformId === 'android') {
                self.sfutils.checkAudioPermission();
            }
        });

        cordova.plugins.firebase.messaging.onBackgroundMessage(function(data){
            console.log('onBackgroundMessage fired (early registration)');
            console.dir(data);

            self.onBackgroundMessageFired = true;


            if (data.linkUrl != undefined && data.linkUrl.length > 0) {

                console.log('opening link: ' + data.linkUrl);

                let retryCount = 0;
                const maxRetries = 3;

                const openLink = function() {
                    if (typeof cordova !== 'undefined' && cordova.InAppBrowser) {
                        cordova.InAppBrowser.open(data.linkUrl, "_system");
                    } else if (retryCount < maxRetries) {
                        retryCount++;
                        console.log('InAppBrowser not ready, retrying... (attempt ' + retryCount + ' of ' + maxRetries + ')');
                        setTimeout(openLink, 500);
                    } else {
                        console.error('InAppBrowser not available after ' + maxRetries + ' attempts');
                    }
                };
                openLink();
            }

            setTimeout(function(){ self.onBackgroundMessageFired = false; }, 5000);
        });

        cordova.plugins.firebase.messaging.onMessage(function(message) {

            if(self.onBackgroundMessageFired == true){
                console.log('onBackgroundMessage already fired, bypassing onMessage');
                self.onBackgroundMessageFired = false;
                return;
            }

            self.eventLog.add('push notification received. data:');
            self.eventLog.add(message);

            if(!self.auth.authenticated){
                self.eventLog.add('not authenticated, terminating.');
                return;
            }

            if(typeof(message.fk) !== "undefined"){
                if(typeof message.diagnostics === 'string') {
                    message.diagnostics = JSON.parse(message.diagnostics);
                }
                self.eventLog.add('incoming vyb follow push notification');
                if(self.logs != undefined) self.logs.updateLog(message);
                return;
            } else if(typeof(message.vybKey) == "undefined"){
                self.eventLog.add("no vybKey, terminating push.");
                return;
            }

            if(typeof(message.soundKey) != "undefined"){
                if(typeof(app.usedSounds.get(message.soundKey,'key')) != "undefined"){
                    app.usedSounds.get(message.soundKey,'key').soundObjectLocal.play();
                } else if(typeof(app.usedSounds.get(message.soundKey,'key')) == "undefined"){
                    app.usedSounds.addSoundFromKey(message.soundKey, true);
                }
            }

            if(self.logs != undefined){
                self.logs.triggerVyb('push', message);
            } else {
                self.eventLog.add('logs not available. retrieving unplayed vybs.');
                self.logs = new self.Logs();
                self.logs.getLogsWithUnplayedSounds();
            }
        }, function(error) {
            console.error('onMessage error:', error);
        });

        cordova.plugins.firebase.messaging.getToken().then(function(fcmToken) {
            self.eventLog.add('FCM token obtained');
            console.log('FCM token:', fcmToken);
            self.waitForAuthAndRegisterDevice(fcmToken);
        }).catch(function(error) {
            console.error('FCM getToken error:', error);
        });
    },

    waitForAuthAndRegisterDevice: function(fcmToken) {
        const self = this;

        const checkAuth = function() {
            if (self.auth && self.auth.authenticated) {
                self.eventLog.add('registering device with FCM token');
                self.auth.registerDevice({registrationId: fcmToken});
            } else {
                setTimeout(checkAuth, 500);
            }
        };

        checkAuth();
    },

    refreshFCMTokenRegistration: function() {
        const self = this;

        if (self.platform !== 'app') {
            return;
        }

        if (typeof cordova === 'undefined' || !cordova.plugins ||
            !cordova.plugins.firebase || !cordova.plugins.firebase.messaging) {
            return;
        }

        if (!self.auth || !self.auth.authenticated) {
            return;
        }

        cordova.plugins.firebase.messaging.getToken().then(function(fcmToken) {
            self.eventLog.add('re-registering device with FCM token after sign-in');
            self.auth.registerDevice({registrationId: fcmToken});
        }).catch(function(error) {
            console.error('Error getting FCM token for post-signin registration:', error);
        });
    },

    receivedEvent: function(id) {
        var self = this;

        this.eventLog.add('reached received event');

        if(StatusBar!=undefined){
            StatusBar.hide();
            setTimeout(function(){StatusBar.show()},200);
        }
        this.platformId = cordova.platformId;
        
        if(typeof(universalLinks)!=="undefined"){
            universalLinks.subscribe('incoming', function (eventData) {
                app.eventLog.add('incoming deep link');
                app.eventLog.add(eventData);
                console.log('incoming deep link');
                console.dir(eventData);
                self.eventData = eventData;

                // Ignore OAuth handler URLs - these should open in browser, not be processed by app
                if(typeof(eventData.path)!=="undefined" && eventData.path.match("__/auth/handler")!=null) {
                    console.log('OAuth handler URL detected - ignoring (should open in browser)');
                    return;
                }

                // OAuth callback handling (both success and error)
                if(typeof(eventData.path)!=="undefined" && eventData.path.match("__/auth/callback")!=null) {
                    console.log('OAuth callback detected');

                    // Close SafariViewController/browsertab immediately
                    if(typeof SafariViewController !== 'undefined') {
                        SafariViewController.hide();
                    } else if(typeof cordova !== 'undefined' && cordova.plugins && cordova.plugins.browsertab) {
                        cordova.plugins.browsertab.close();
                    }

                    // If there's an error, show it to the user
                    if(typeof(eventData.params.firebaseError)!=="undefined") {
                        console.log('OAuth callback error detected');
                        window.sessionStorage.removeItem("signInInProgress");
                        window.sessionStorage.removeItem("signInInProgressTime");
                        try {
                            var errorData = JSON.parse(decodeURIComponent(eventData.params.firebaseError));
                            console.log('Firebase auth error:', errorData);
                            app.dialog.alert('Sign in failed: ' + (errorData.message || 'Network error occurred'));
                        } catch(e) {
                            console.log('Error parsing firebaseError:', e);
                            app.dialog.alert('Sign in failed due to a network error. Please try again.');
                        }
                        app.utils.stopSpinner();
                    } else {
                        console.log('OAuth callback successful - auth will complete via onAuthStateChanged');
                    }

                    return;
                }

                //email sign-in, verification and password reset links
                if(typeof(eventData.params.oobCode)!=="undefined") self.handleEmailAction(eventData.params, eventData.url);

                //for ios
                if(typeof(eventData.params.link)!=="undefined" && eventData.params.link.match("sk=")) app.utils.captureSubscriptionKeyFromDeepLink(eventData.params.link);

                //subscriptions
                if(typeof(eventData.params.sk)!=="undefined"){
                    window.localStorage.setItem("subscriptionKey",eventData.params.sk);
                    if(app.auth.authenticated) app.utils.processSubscription();
                    else app.renderMainLoginPage();
                }
                if(typeof(eventData.path)!=="undefined" && eventData.path.match("subscribe")!=null){
                    window.localStorage.setItem("subscriptionKey", eventData.path.split("/").pop());
                    if(app.auth.authenticated) app.utils.processSubscription();
                    else app.renderMainLoginPage();
                }

                //serviceauth
                if(typeof(eventData.params.client_id)!=="undefined" && eventData.params.client_id.length>0) app.queryParams = eventData.params;

                //auth redirect, TODO, google sign-in proxy fix for ios
                // if(typeof(eventData.path)!=="undefined" && eventData.path.match("__/auth/handler")!=null){
                //     console.log("caught an auth redirect");
                //     console.log(eventData.url);
                // }

            });
        }

        this.init();
    },

    init: async function () {

        const self = this;

        self.eventLog.add('begin init');

        // Clear any stale sign-in flags on app startup
        window.sessionStorage.removeItem("signInInProgress");
        window.sessionStorage.removeItem("signInInProgressTime");

        self.pageSwitcher = require('./switchers/pageswitcher');

        self.utils.captureQueryParams();

        this.loadTemplates();
        this.loadModels();
        this.loadCollections();
        this.loadPageViews();

        const status = await this.checkStatus();
        if (status === "down") {
            this.renderMaintenancePage();
            return;
        }

        this.auth = new this.Auth();

        //restore org context (cleared on signout by localStorage.clear())
        if(window.localStorage.getItem('vybit_org_token')){
            try {
                this.auth.set('orgToken', window.localStorage.getItem('vybit_org_token'));
                this.auth.set('orgContext', JSON.parse(window.localStorage.getItem('vybit_org_context')));
            } catch(e) {
                window.localStorage.removeItem('vybit_org_token');
                window.localStorage.removeItem('vybit_org_context');
            }
        }

        //landing page (and optional section) carried across the reload
        var landing = window.localStorage.getItem('vybit_landing');
        if(landing){
            window.localStorage.removeItem('vybit_landing');
            var parts = landing.split(':');
            this.reloadPageName = parts[0];
            if(parts[1]) this.landingSection = parts[1];
        }

        if(this.platform=="app") this.utils.firebaseAuthPrep();

        this.firebase = firebase;

        //browsers
        if(this.platform=="browser") this.config.firebase.authDomain = window?.location?.host || this.config.hostName;

        if(this.platformId=="android") {
            this.config.androidSoundLib = cordova.file.externalRootDirectory;
            this.config.firebase.authDomain = this.config.firebase.iOsAuthDomain;
        }

        if(this.platformId=="ios") {
            this.config.firebase.authDomain = this.config.firebase.iOsAuthDomain;
            document.body.classList.add('ios-safe-area');
        }

        if(app.queryParams.client_id!=undefined || window.localStorage.getItem("serviceAuth")!=null){
            this.config.firebase.authDomain = window?.location?.host || this.config.firebase.serviceAuthDomain;
        }

        this.firebase.initializeApp(this.config.firebase);

        // Explicitly enable LOCAL persistence for Cordova to ensure auth state persists
        if(this.platform === 'app') {
            this.firebase.auth().setPersistence(this.firebase.auth.Auth.Persistence.LOCAL)
                .then(function() {
                    console.log('Firebase auth persistence set to LOCAL for Cordova');
                })
                .catch(function(error) {
                    console.error('Error setting Firebase auth persistence:', error);
                });
        }

        if(this.queryParams.oobCode!=undefined) this.handleEmailAction(this.queryParams);

        if(this.platform === 'app') {
            this.firebase.auth().getRedirectResult()
                .catch(function(error) {
                    window.sessionStorage.removeItem("signInInProgress");
                    window.sessionStorage.removeItem("signInInProgressTime");
                });
        }

        this.firebase.auth().onAuthStateChanged(function(user) {

            if(self.platformId == "ios") cordova.plugins.backgroundMode.disable();

            self.eventLog.add('begin firebase.auth.onAuthStateChanged, user:');
            console.dir(user);
            if(user){

                window.sessionStorage.removeItem("authInProgress");
                window.sessionStorage.removeItem("signInInProgress");
                window.sessionStorage.removeItem("signInInProgressTime");

                //password signups stay out until the address is verified; every other provider verifies it up front
                if(user.emailVerified === false){
                    self.turnAwayUnverified(user);
                    return;
                }

                self.auth.set('idToken', user._lat);
                self.auth.set('provider',user.providerData[0].providerId);
                //a fresh firebase user always means sign-in, even if a signout request is still in flight
                self.auth.set('mode','signin');
                self.auth.fetch({
                    success: function(model,response){
                        model.set('authenticated',response.authenticated);
                        model.set('jwtToken',response.jwtToken);
                        self.auth.checkAuth();
                        self.refreshFCMTokenRegistration();
                        //self.lastActivity = Math.round((new Date()).getTime() / 1000);
                    },
                    error: function(model,response){
                        console.log('auth failed:');
                        console.log(response);
                        model.set('authenticated',false);
                        self.auth.checkAuth();
                    }
                });
            }else{
                // Restore Android Google auth from localStorage (custom backend auth)
                if(self.platform === 'app' && self.platformId === 'android' &&
                   window.localStorage.getItem('vybit_auth_authenticated') === 'true') {
                    const authData = {
                        idToken: window.localStorage.getItem('vybit_auth_idToken'),
                        jwtToken: window.localStorage.getItem('vybit_auth_jwtToken'),
                        provider: window.localStorage.getItem('vybit_auth_provider')
                    };
                    self.auth.set('idToken', authData.idToken);
                    self.auth.set('jwtToken', authData.jwtToken);
                    self.auth.set('provider', authData.provider);
                    self.auth.set('authenticated', true);
                }
                self.auth.checkAuth();
            }
        });

        self.utils.startBackgroundRefresh();
    },

    handleEmailAction: function(params, link){
        if(params.mode === "verifyEmail") this.applyEmailVerification(params.oobCode);
        else if(params.mode === "resetPassword") this.preparePasswordReset(params.oobCode);
        else if(params.mode === "signIn") this.checkEmailSignIn(link);
    },

    applyEmailVerification: function(code){
        const self = this;
        this.firebase.auth().applyActionCode(code)
            .then(function(){
                self.setLoginMessage('Your email address is verified. Sign in with your password.');
            })
            .catch(function(error){
                console.log('applyActionCode failed:', error);
                self.setLoginMessage('That verification link is invalid or has expired. Sign in to request a new one.');
            });
    },

    preparePasswordReset: function(code){
        const self = this;
        this.firebase.auth().verifyPasswordResetCode(code)
            .then(function(email){
                self.pendingPasswordReset = {code: code, email: email};
                self.setLoginMessage('Choose a new password for <b>' + email + '</b>.');
                const page = self.loginPage();
                if(page) page.openNewPasswordMode();
            })
            .catch(function(error){
                console.log('verifyPasswordResetCode failed:', error);
                self.setLoginMessage('That password reset link is invalid or has expired. Use "Forgot password?" to request a new one.');
            });
    },

    //the login page is only showing while signed out; kept apart from currentPage, which night mode walks
    loginPage: function(){
        return !this.auth.authenticated && this.loginPageView ? this.loginPageView : null;
    },

    //links are processed before the login page exists, so fall back to the preset the page reads on render
    setLoginMessage: function(message){
        const page = this.loginPage();
        if(page) page.model.set('loginMessage', message);
        else window.localStorage.setItem('loginMessage', message);
    },

    //needs the Firebase user to send the mail, so this runs client-side; the server 403 is the backstop
    turnAwayUnverified: async function(user){
        try {
            //once per address per session, or every unverified sign-in attempt would resend it
            if(window.sessionStorage.getItem('verificationSentTo') !== user.email){
                await user.sendEmailVerification(this.utils.emailActionSettings());
                window.sessionStorage.setItem('verificationSentTo', user.email);
            }
        } catch(error) {
            console.log('sendEmailVerification failed:', error);
        }
        //written to the preset, not the page model: the sign-out re-renders the login page
        window.localStorage.setItem('loginMessage', 'Verify your email address with the link sent to <b>' + this.utils.escapeHtml(user.email) + '</b>, then sign in.');
        return this.firebase.auth().signOut();
    },

    checkStatus: async function() {
        return new Promise((resolve, reject) => {
            const statusCheck = new app.Status();
            statusCheck.fetch({
                success: function(model, response) {
                    resolve(model.status); // assuming model.status holds "up" or "down"
                },
                error: function(model, response) {
                    console.error('status check failed:', response);
                    resolve("down"); // treat fetch errors as a "down" status
                }
            });
        });
    },

    checkEmailSignIn: async function(link=this.incomingUrl){
        if (!app.firebase.auth().isSignInWithEmailLink(link)) return;

        if (this.platform === "browser"
            && /iPhone|iPad|iPod/.test(navigator.userAgent)
            && this.queryParams.fallback !== "1") {
            this.renderOpenInAppPage(link);
            return;
        }

        var email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
            email = await app.dialog.prompt('Please provide the email for confirmation:', {title: 'Confirm your email', type: 'email', placeholder: 'you@example.com'});
        }
        app.firebase.auth().signInWithEmailLink(email, link)
            .then(function(result) {
                window.localStorage.removeItem('emailForSignIn');
                console.log('email sign in confirmed: ', result);
                window.localStorage.setItem('signInMethod', 'email link');
            })
            .catch(function(error) {
                console.log('email sign in error: ', error);
                if(error.code=="auth/invalid-action-code"){
                    app.dialog.alert('Error: Invalid Authentication Link');
                }
            });
    },

    renderOpenInAppPage: function(link){
        var url = new URL(link);
        var params = url.searchParams.toString();
        var customSchemeLink = "vybit://signin?" + params;
        var browserFallbackLink = window.location.origin + "/?" + params + "&fallback=1";
        var appStoreLink = "https://apps.apple.com/app/id1519874653";

        var overlayId = "vybit-open-in-app";
        var attachOverlay = function() {
            if (document.getElementById(overlayId)) return;
            var overlay = document.createElement("div");
            overlay.id = overlayId;
            overlay.style.cssText = "position:fixed;top:0;right:0;bottom:0;left:0;background:darkorange;z-index:2147483647;display:flex;align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,sans-serif;color:#fff";
            overlay.innerHTML =
                '<div style="max-width:420px;padding:24px;text-align:center">' +
                    '<img src="/css/images/vybit_logo.png" alt="Vybit" style="width:140px;height:auto;margin-bottom:24px">' +
                    '<h2 style="margin:0 0 16px;color:#fff">Sign in to Vybit</h2>' +
                    '<p style="margin:0 0 32px;color:#fff">Tap below to finish signing in.</p>' +
                    '<a href="' + customSchemeLink + '" style="display:inline-block;padding:14px 28px;background:#000;color:#fff;text-decoration:none;border-radius:8px;font-weight:600">Open in the Vybit app</a>' +
                    '<p style="margin:32px 0 0;font-size:13px;color:#fff">' +
                        '<a href="' + browserFallbackLink + '" style="color:#fff;text-decoration:underline">Continue in browser</a>' +
                    '</p>' +
                    '<p style="margin:16px 0 0;font-size:13px;color:#fff">' +
                        "Don't have the app? " +
                        '<a href="' + appStoreLink + '" style="color:#fff;text-decoration:underline">Get it on the App Store</a>' +
                    '</p>' +
                '</div>';
            document.body.appendChild(overlay);
        };

        attachOverlay();
        var pollId = setInterval(attachOverlay, 200);
        setTimeout(function() { clearInterval(pollId); }, 30000);
    },

    renderMainLoginPage: function(){
        var modelOptions = {mainTitle : 'Welcome to Vybit!'};
        if(window.localStorage.getItem('demoSoundName')){
            modelOptions.loginMessage = '<span class="vib">Sign In to Create Your Vybit Using Sound&nbsp;</span>' +
                '<span class="vib">"' + window.localStorage.getItem('demoSoundName') + '"</span>' +
            ' <span class="vsdemoclear"> &#9447;</span>';
        }

        this.renderLoginPage(modelOptions);
    },

    renderWwwPage: function(){
        if(window.location.pathname=="/public"){
            this.renderPage("PublicVybsPage");
        }else{
            this.renderPage("WwwPage");
        }
    },

    renderPwPage: async function(){

        const modelOptions = {
            showGettingStarted: false,
            loginMessage: 'Sign In to Manage Subscription Plan'
        };

        if(this.auth.authenticated){

            if(app.queryParams.pk!=undefined && app.queryParams.pk != app.auth.personKey){
                app.auth.signOut();
                app.renderLoginPage(modelOptions);
            }else{
                app.loadProfile();
                app.loadMeter();
                this.renderPage("PwPage");
            }

        }else{
            this.renderLoginPage(modelOptions);
        }
    },

    renderLoginPage: function(modelOptions={}){
        var pageview = new app.LoginPageView({
            el: document.querySelector('body'),
            modelOptions: modelOptions
        });
        this.loginPageView = pageview;
        domready(function() {
            pageview.render();
        });
    },

    renderServiceAuth: function(){
        // Initialize ServiceAuth model to handle OAuth flow and parameter validation
        if (!this.serviceAuthModel) {
            this.serviceAuthModel = new app.ServiceAuth();
        }
        
        if(this.auth.authenticated){
            var pageview = new app.ServiceAuthPageView({
                el: document.querySelector('body'),
                serviceAuthModel: this.serviceAuthModel
            });
        }else{
            var pageview = new app.LoginPageView({
                el: document.querySelector('body'),
                modelOptions: {showGettingStarted: false},
                serviceAuthModel: this.serviceAuthModel
            });
        }
        this.loginPageView = pageview;
        domready(function() {
            pageview.render();
        });
    },

    renderSubscriptionPage: function(){
        var pageview = new app.SubscriptionPageView({
                el: document.querySelector('body')
        });
        domready(function() {
            pageview.render();
        });
    },

    renderDemoSoundsPage: function(){
        var pageview = new app.DemoSoundsPageView({
            el: document.querySelector('body'),
            viewOptions: {"mode": "sounds"}
        });
        this.currentPage = pageview;
        domready(function() {
            pageview.render();
        });
    },

    renderVybPageForDemoSound: function(){
        var sound = new app.Sound({key: window.localStorage.getItem('demoSoundKey')});
        sound.fetch({
            success: function(model,response){
                window.localStorage.removeItem('demoSoundKey');
                window.localStorage.removeItem('demoSoundName');
                console.log('loading demo sound ' + model.key);
                app.sounds.add(model);
                app.utils.loadVybWithSound(model);
            },
            error: function(err){
                console.log('error loading vyb for demo sound');
                console.dir(err);
            }
        });
    },

    renderMaintenancePage: function(){
        this.renderPage("MaintenancePage");
    },

    //initialize web socket
    initSocket: function(){
        const self = this;

        this.eventLog.add('initializing socket');

        // If socket already exists, remove all listeners to prevent duplicates
        if(this.socket){
            this.socket.off('newlog');
            this.socket.off('vybSignal');
            this.socket.off('connect');
            this.socket.off('disconnect');
            this.socket.off('connect_error');
            this.socket.off('reconnect');
            this.socket.off('reconnect_error');
            this.socket.off('reconnect_failed');
        }

        this.socket = socket(this.config.webSocketUri,{
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 10000,
            maxReconnectionAttempts: Infinity,
            timeout: 20000,
            transportOptions: {
                polling: {
                    extraHeaders: {
                        'Authorization': self.auth.jwtToken
                    }
                }
            }
        });

        //update activity log
        this.socket.on('newlog', function(data){
            self.eventLog.add('incoming log!');
            self.eventLog.add('PING! ' + data.diagnostics.vybName +
                ': ' +
                '' + data.diagnostics.vybDescription);
            console.dir(data);
            if(self.logs!=undefined) self.logs.updateLog(data);
        });

        //trigger vybs
        this.socket.on('vybSignal', function(data){
            self.eventLog.add('incoming vyb!');
            self.eventLog.add('PING! ' + data.vybName +
                ': ' +
                '' + data.vybDescription);
            console.dir(data);
            if(self.logs!=undefined) self.logs.triggerVyb('socket',data);

            // runOnce: update on/off switch if vyb was turned off
            if(self.vyb && data.vybKey === self.vyb.key && (self.vyb.runOnceOn || data.runOnce)){
                self.vyb.set('status', 'off');
            }

            // reminder: remove fired reminder from triggerSettings
            if(self.vyb && data.vybKey === self.vyb.key && data.reminderId){
                self.vyb.updateTriggerSettings(function(ts){
                    if(ts.reminders) ts.reminders = ts.reminders.filter(function(r){ return r.id !== data.reminderId; });
                });
            }
        });

        this.socket.on('connect',function(data){
            self.eventLog.add('socket connected');
            if(self.loadedForPersonKey !== self.auth.personKey) self.loadData();
        });

        this.socket.on('disconnect', function(reason){
            self.eventLog.add('socket disconnected: ' + reason);
            
            // Only manually reconnect if server initiated the disconnect
            if (reason === 'io server disconnect') {
                setTimeout(() => {
                    self.socket.connect();
                }, 1000);
            }
        });

        // Add comprehensive error handling
        this.socket.on('connect_error', function(error){
            self.eventLog.add('socket connect error: ' + error);
            // Check if it's an auth error
            if (error.toString().includes('401') || error.toString().includes('unauthorized')) {
                self.eventLog.add('auth error detected, refreshing token');
                if (self.auth && self.auth.checkAuth) {
                    self.auth.checkAuth();
                }
            }
        });

        this.socket.on('reconnect', function(attemptNumber){
            self.eventLog.add('socket reconnected after ' + attemptNumber + ' attempts');
            if(self.loadedForPersonKey !== self.auth.personKey) self.loadData();
        });

        this.socket.on('reconnect_error', function(error){
            self.eventLog.add('socket reconnect error: ' + error);
        });

        this.socket.on('reconnect_failed', function(){
            self.eventLog.add('socket reconnection failed permanently');
            // Could show user notification about connection issues
        });

        // Initialize connection health monitoring
        this.monitorSocketHealth();
    },

    // Add connection state monitoring
    monitorSocketHealth: function() {
        const self = this;
        
        // Simple periodic connection check
        this.socketHealthInterval = setInterval(() => {
            if (this.socket) {
                if (!this.socket.connected) {
                    self.eventLog.add('socket not connected, status: ' + this.socket.disconnected);
                }
            }
        }, 30000); // Check every 30 seconds
        
        // Clear interval when socket disconnects permanently
        this.socket.on('disconnect', () => {
            if (this.socketHealthInterval) {
                clearInterval(this.socketHealthInterval);
                this.socketHealthInterval = null;
            }
        });

        // Restart monitoring on reconnect
        this.socket.on('connect', () => {
            if (!this.socketHealthInterval) {
                this.monitorSocketHealth();
            }
        });
    },

    //models defined here
    loadModels: function(){
        this.Sound = require('./models/sound');
        this.Profile = require("./models/profile");
        this.Meter = require("./models/meter");
        this.Auth = require('./models/auth');
        this.VybFollowing = require('./models/vybfollowing');
        this.VybPeep = require('./models/vybpeep');
        this.OrgMember = require('./models/orgmember');
        this.Vyb = require('./models/vyb');
        this.Subscription = require('./models/subscription');
        this.Xhr = require('./models/xhr');
        this.Param = require('./models/param');
        this.SubscriptionPortal = require('./models/subscriptionportal');
        this.Status = require('./models/status');
        this.Developer = require('./models/developer');
        this.ServiceAuth = require('./models/serviceauth');
    },

    //collections defined here
    loadCollections: function(){
        this.Sounds = require('./collections/sounds');
        this.SoundCandidates = require('./collections/soundcandidates');
        this.UsedSounds = require('./collections/usedsounds');
        this.Vybs = require('./collections/vybs');
        this.VybsFollowing = require('./collections/vybsfollowing');
        this.Logs = require('./collections/logs');
        this.VybPeeps = require('./collections/vybpeeps');
        this.OrgMembers = require('./collections/orgmembers');
        this.Subscriptions = require('./collections/subscriptions');
    },

    //page views defined and some instantiated here
    loadPageViews: function(){
        this.LoginPageView = require('./views/pages/loginpage');

        this.LogPageView = require('./views/pages/logpage');
        this.logPageView = new this.LogPageView();

        this.VybListPageView = require('./views/pages/vyblistpage');
        this.vybListPageView = new this.VybListPageView();

        this.ProfilePageView = require('./views/pages/profilepage');
        this.profilePageView = new this.ProfilePageView();

        this.SoundsPageView = require("./views/pages/soundspage");
        this.soundsPageView = new this.SoundsPageView({mode:"sounds"});

        this.DeveloperPageView = require("./views/pages/developerpage");
        this.developerPageView = new this.DeveloperPageView();

        this.PeepsPageView = require("./views/pages/peepspage");

        this.VybPageView = require("./views/pages/vybpage");
        this.VybFollowingPageView = require("./views/pages/vybfollowingpage");
        this.SoundPageView = require("./views/pages/soundpage");
        this.PeepPageView = require("./views/pages/peeppage");
        this.SoundAcquisitionPageView = require("./views/pages/soundacquisitionpage");
        this.DocsPageView = require("./views/pages/docspage");
        this.WwwPageView = require("./views/pages/wwwpage");
        this.PwPageView = require("./views/pages/pwpage");
        this.EventLogPageView = require("./views/pages/eventlogpage");
        this.ServiceAuthPageView = require("./views/pages/serviceauthpage");
        this.DemoSoundsPageView = require("./views/pages/demosoundspage");
        this.SubscriptionPageView = require("./views/pages/subscriptionpage");
        this.SubscriptionCardPageView = require("./views/pages/subscriptioncardpage");
        this.PublicVybsPageView = require("./views/pages/publicvybspage");
        this.MaintenancePageView = require("./views/pages/maintenancepage");
    },

    renderPage: function(pageView=null){
        if(app.queryParams?.p=="profile") pageView = "ProfilePage";
        if(!pageView && app.reloadPageName){
            pageView = app.reloadPageName;
        }
        var pageview = new MainView({
            el: document.querySelector('body'),
            pageView: pageView
        });

        domready(function() {
            pageview.render();
        });
    },

    loadLogs: function(renderPage=false){
        this.eventLog.add('loading logs');
        const self = this;
        this.logs.fetch({
            success: function(collection,response,options){
                console.log('logs loaded');
                self.loadVybsFollowing();
                self.loadMeter();
                if(renderPage) self.renderPage();
                delete app.reloadPageName;
            },
            error: function(collection,response,options){
                self.eventLog.add('cannot retrieve logs','error');
            }
        });

    },

    loadVybsFollowing: function(){
        var self = this;
        app.vybsfollowing.fetch({
            success: function(collection,response,options){
                self.eventLog.add('loaded vybsfollowing');
                self.loadProfile();
            },
            error: function(collection,response,options){
                self.eventLog.add('cannot retrieve vybsfollowing','error')
            }
        });
    },

    loadSounds: function(params={}){

        var self = this;

        //handle incoming sound search
        if(app.queryParams.p!=undefined && app.queryParams.p=="sounds" && app.queryParams.squery!=undefined && app.queryParams.squery.length>0) params.squery = app.queryParams.squery;

        this.sounds = new this.Sounds();
        var data = {};
        if(params.squery!=undefined){
            data.query = decodeURIComponent(params.squery.replace(/\+/g, ' '));
            this.sounds.searchQuery = data.query;
        }

        this.soundCandidates = new this.SoundCandidates();

        this.sounds.fetch({
            data: data,
            success: function(collection,response,options){
                if(params.squery==undefined){
                    collection.add({key:'none', name:'none', type: 'mp3'},{at:0});
                }else{
                    if(collection.length>10 && self.auth.authenticated==false){
                        app.renderDemoSoundsPage();
                    }else{
                        app.loadSoundCandidates(params);
                    }
                }
            },
            error: function(collection,response,options){
                self.eventLog.add('cannot retrieve sounds','error');
            }
        });

    },

    loadSoundCandidates: function(){

        var self = this;

        this.soundCandidates.fetch({
            data: {
                query: app.sounds.searchQuery,
                filter: 'existing'
            },
            success: function(collection,response,options){
                console.log('retrieved candidate sounds for demo page');
                        if(self.auth.authenticated==false) app.renderDemoSoundsPage();
                        else app.renderPage("SoundsPage");
            },
            error: function(collection,response,options){
                console.log('cannot retrieve candidate sounds for demo page','error');
            }
        });
    },

    //per-person state; keep in step with the new this.X() sites in the loaders
    USER_DATA: ['sounds','soundCandidates','usedSounds','subscriptions','vybs',
        'vybsfollowing','vybPeeps','logs','profile','meter'],

    clearUserData: function(){
        const self = this;
        this.USER_DATA.forEach(function(name){ delete self[name]; });
        this.loadedForPersonKey = null;
    },

    loadData: function(){

        this.eventLog.add("loading data");

        const self = this;

        this.loadedForPersonKey = this.auth.personKey;

        this.vybsfollowing = new this.VybsFollowing();
        this.logs = new this.Logs();

        this.loadSounds();

        this.loadUsedSounds();

        this.loadSubscriptions();

        this.vybs = new this.Vybs();
        this.vybs.fetch({
            success: function(collection,response,options){
                self.loadLogs(true);
                console.log('loaded vybs');
            },
            error: function(collection,response,options){
                self.eventLog.add('cannot retrieve vybs','error')
            }
        });

        this.vybPeeps = new this.VybPeeps();

    },

    isManagingOrg: function(orgKey){
        return !!(this.auth && this.auth.orgToken && this.auth.orgContext
            && (orgKey === undefined || this.auth.orgContext.key === orgKey));
    },

    //enter (org = {key, name}) or leave (org = null) org management context;
    //reloads so every collection refetches under the new context
    switchOrgContext: function(org){
        var self = this;

        if(!org){
            window.localStorage.removeItem('vybit_org_token');
            window.localStorage.removeItem('vybit_org_context');
            window.localStorage.setItem('vybit_landing', 'ProfilePage:memberships');
            window.location.reload();
            return;
        }

        global.jQuery.ajax(Object.assign({
            url: this.config.restApiUrl + '/org/switch',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({orgKey: org.key}),
            success: function(response){
                window.localStorage.setItem('vybit_org_token', response.jwtToken);
                window.localStorage.setItem('vybit_org_context', JSON.stringify(response.org));
                window.localStorage.setItem('vybit_landing', 'VybListPage');
                window.location.reload();
            },
            error: function(xhr){
                self.eventLog.add('error switching to org ' + org.key, 'error');
                app.dialog.alert('Could not switch to ' + (org.name || 'org') + '. Your manager access may have been revoked.');
            }
        }, this.utils.setPersonalAuthTokenHeader()));
    },

    loadSubscriptions: function(){
        this.subscriptions = new this.Subscriptions();
        this.subscriptions.fetch({
            success: function(collection,response,options){
                console.log('loaded subscriptions');
            },
            error: function(collection,response,options){
                console.log('error loading subscriptions');
            }
        });
    },

    loadProfile: function(){
        var self = this;

        this.profile = new this.Profile();
        this.profile.fetch({
            success : function(model, response, options){
                app.profile = model;

                if(self.platform=='app' && !app.serviceAuth){
                    self.createPushChannels();
                }else if(app.serviceAuth){
                    window.localStorage.setItem("key",model.key);
                }
                if(model.type=="user" && window.location.hostname!="dev.vybit.net") window.console.log = function(){};
                console.log('loaded profile');
                if(app.meter){
                    app.meter.name = model.name;
                    app.meter.email = model.email;
                }
                // Set geofences after vybs, vybsfollowing, and profile are loaded
                if(self.platform=='app' && typeof(VybitPlugin)!="undefined"){
                    self.glutils.manage();
                }
            },
            error: function(){
                self.eventLog.add('cannot retrieve profile','error');
                if(self.platform=='app' && !app.serviceAuth){
                    self.createPushChannels();
                }
            }
        });

    },

    loadMeter: function(){
        var self = this;

        this.meter = new this.Meter();
        this.meter.fetch({
            success : function(model, response, options){
                app.meter = model;
                console.log('loaded meter');
                if(app.currentPageName=="ProfilePage") app.renderPage("ProfilePage");
            },
            error: function(){
                self.eventLog.add('cannot retrieve meter','error');
            }
        });

    },

    loadUsedSounds: function(){
        this.usedSounds = new this.UsedSounds({
            key: 'none',
            name: 'none',
            type: 'mp3'
        });
        this.usedSounds.fetch({
            success: function(collection,response,options){
                collection.soundsSetUp();
            },
            error: function(collection,response,options){
                console.log('cannot retrieve used sounds','error');
            }
        });
    },

    loadTemplates: function(){
        this.templates = [];
        this.templates.TextTemplate = require('./templates/components/text.html');
        this.templates.TextAreaTemplate = require('./templates/components/textarea.html');
        this.templates.VybTypeTemplate = require('./templates/components/vybtype.html');
        this.templates.VybAccessTemplate = require('./templates/components/vybaccess.html');
        this.templates.SendPermissionsTemplate = require('./templates/components/sendpermissions.html');
        this.templates.TriggerTypeTemplate = require('./templates/components/triggertype.html');
        this.templates.VybFrequencyTemplate = require('./templates/components/vybfrequency.html');
        this.templates.VybTestTemplate = require('./templates/components/vybtest.html');
        this.templates.VybDeleteTemplate = require('./templates/components/vybdelete.html');
        this.templates.SendNotificationTemplate = require('./templates/components/sendnotification.html');
        this.templates.DeclineInviteTemplate = require('./templates/components/declineinvite.html');
        this.templates.DisplayTemplate = require('./templates/components/display.html');
        this.templates.ScheduleEditTemplate = require('./templates/components/schedule_edit.html');
        this.templates.GeofenceEditTemplate = require('./templates/components/geofence_edit.html');
        this.templates.ReminderEditTemplate = require('./templates/components/reminder_edit.html');
    },

    createPushChannels: function(){
        this.eventLog.add('creating push notification channels');

        if (this.fsutils) {
            this.fsutils.createDefaultPushChannel();
            this.fsutils.createSilentChannel();
        }
    }
});

app.initialize();

window.app = app;
